import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { icon_good_blue } from '@/assets';
import AddMemberConfirmationStyles from './AddMemberConfirmation.style';
import { IAddMemberSchema } from '../../schemas/addMember.schema';

const AddMemberConfirmation = () => {
  const { getValues } = useFormContext<Partial<IAddMemberSchema>>();
  const { userName } = getValues();
  const { t } = useTranslation();

  return (
    <Stack>
      <img
        className={AddMemberConfirmationStyles.image}
        src={icon_good_blue}
        alt="check"
      />
      <Typography variant="h4" className={AddMemberConfirmationStyles.title}>
        {t('crtMmbCreated', { name: userName })}
      </Typography>
    </Stack>
  );
};

export default AddMemberConfirmation;
